import { z } from 'zod';
import { IsoDateTimeSchema, UuidSchema } from './common.js';

/**
 * Bekannte V1.0-Flags (alle default false). Erweiterbar ohne Schema-Bruch.
 *
 * `staffing_neu`: Der Key ist HISTORISCH. Die Ansicht heißt seit PV-016 sichtbar
 * "Staffing" (die alte Sicht "Staffing alt"); das Flag schaltet zusätzlich die
 * KFML-Worklist. Bewusst NICHT umbenannt — der Key ist Primärschlüssel einer
 * laufenden Prod-Zeile in `feature_flags`, ein Rename müsste `enabled` migrieren.
 * Siehe docs/features/kfml-worklist/architektur.md.
 *
 * `befunde`: Projekt-Befunde (PV-052) — Prüflauf nach Zeitplan, Sofort-Neuprüfung,
 * Arbeitsliste in Mission Control, Marker an Karten, Befunde in der Hinweisleiste.
 *
 * `planner_import`: Planner-Import (PV-009) — seit #122 standardmäßig aus. Aus → alle
 * `/v1/planner-import`-Endpunkte 403, Abschnitt in den Einstellungen samt Historie ausgeblendet.
 */
export const FEATURE_FLAG_KEYS = [
  'ai_dashboard_briefing',
  'mission_briefings_in_project_detail',
  'briefings_library',
  'staffing_suggested_moves',
  'project_detail_tasks_tab',
  'staffing_neu',
  'mcp_server',
  'befunde',
  'planner_import',
] as const;
export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[number];

export const FeatureFlagSchema = z.object({
  key: z.string().min(1),
  enabled: z.boolean(),
  description: z.string().nullable().optional(),
  updated_by: UuidSchema.nullable().optional(),
  updated_at: IsoDateTimeSchema,
});
export type FeatureFlag = z.infer<typeof FeatureFlagSchema>;

export const UpdateFeatureFlagInputSchema = z.object({
  enabled: z.boolean(),
});
export type UpdateFeatureFlagInput = z.infer<typeof UpdateFeatureFlagInputSchema>;
